import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const reasons = ['Built for small businesses – not enterprises', 'No long-term contracts or bloated software', 'Plain-English consulting (no AI buzzwords)', 'Fast implementation (weeks, not months)', 'Clear ROI tied directly to hiring outcomes'];
const idealFor = ['Founder-led companies', 'Teams hiring 5–100+ roles per year', 'Businesses overwhelmed by applicant volume', 'Companies priced out of enterprise HR AI tools'];
export function WhyUs() {
  return <section className="py-16 md:py-24 bg-slate-900 text-white" data-id="element-108">
      <div className="max-w-7xl mx-auto px-6" data-id="element-109">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-110">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-111">
            <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-112">
              Why Small Businesses Choose Us for AI Hiring Consulting
            </h2>
            <ul className="space-y-6" data-id="element-113">
              {reasons.map((reason, index) => <li key={index} className="flex items-start gap-4" data-id="element-114">
                  <div className="mt-1 bg-blue-600/20 p-1 rounded-full" data-id="element-115">
                    <Check className="w-5 h-5 text-blue-400" data-id="element-116" />
                  </div>
                  <span className="text-lg text-slate-200" data-id="element-117">{reason}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-slate-800 rounded-2xl p-8 md:p-12 border border-slate-700" data-id="element-118">
            <h3 className="text-2xl font-bold mb-6 text-white" data-id="element-119">
              Designed for Growing Small Businesses
            </h3>
            <p className="text-slate-400 mb-8" data-id="element-120">
              We specialize in helping specific types of organizations that are
              often overlooked by big tech.
            </p>
            <div className="space-y-4" data-id="element-121">
              {idealFor.map((item, index) => <div key={index} className="flex items-center gap-3" data-id="element-122">
                  <div className="w-2 h-2 bg-amber-500 rounded-full" data-id="element-123" />
                  <span className="text-slate-300 font-medium" data-id="element-124">{item}</span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}